import { render, staticRenderFns } from "./RegisterationsManager.vue?vue&type=template&id=acd24be8&"
import script from "./RegisterationsManager.vue?vue&type=script&lang=js&"
export * from "./RegisterationsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports